import startCase from 'lodash.startcase';
import { isMobileScreen } from './screen';
import { getDayAsString, getTimeAsString } from './dateTime';

const MEDIA_SUPER_BRAND_NAME = 'Media Super';
const CBUS_BRAND_NAME = 'CBus';

export const GetECID = async() => {
    const alloyExists = window.alloy && typeof window.alloy === 'function';
    if (!alloyExists) {
        return '';
    }

    const identity = (await window.alloy('getIdentity').catch(e => {
        console.error(e);
        return '';
    }));

    return identity?.identity?.ECID;
};

const getSiteBrand = () => {
    let siteBrand = '';
    if (window.__SITE_INFO__ && window.__SITE_INFO__.siteBrand) {
        // get brand from global site info
        // eslint-disable-next-line prefer-destructuring
        siteBrand = window.__SITE_INFO__.siteBrand;
    } else {
        // fallback - determine brand from body class
        const bodyClass = document.querySelector('body').classList;
        siteBrand = bodyClass.contains('brand-media-super')
            ? MEDIA_SUPER_BRAND_NAME
            : bodyClass.contains('brand-cbus-super')
                ? CBUS_BRAND_NAME
                : '';
    }

    return siteBrand;
};

const sleep = ms => {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
};


const retrievePageName = (pageUrl = null) => {
    const rawPageUrl = pageUrl ?? '';
    let pagePrefix;

    const siteBrand = getSiteBrand();

    if (siteBrand === MEDIA_SUPER_BRAND_NAME) {
        pagePrefix = 'MS: ';
    } else if (rawPageUrl) {
        // Note that the member.aas and employer.aas checks are most likely redundant
        // because these don't currently provide window.digitalData.page.pageInfo.pageUrl
        // however the checks are here just in case.
        if (rawPageUrl.match('/portals/employer/') || rawPageUrl.match('employer/login')) { // New Employer Portal
            pagePrefix = '';
        } else if (rawPageUrl.match(/\/manage-account|\/portal|member\.aas/g)) { // Member Portal
            pagePrefix = 'LMP: ';
        } else if (rawPageUrl.match(/employer\.aas/g)) { // Link Employer Portal
            pagePrefix = 'LEP: ';
        } else {
            pagePrefix = 'CBS: '; // Public Site (redundant condition)
        }
    } else if (window.digitalData.page.attributes) {
        pagePrefix = `${window.digitalData.page.attributes.siteID || 'CBS'}: `;
    }

    const pagePathname = new URL(rawPageUrl).pathname;
    let cleanedPaths = '';

    if (pagePathname === '/' || pagePathname === '') {
        // consider homepage / home
        cleanedPaths = 'Home';
    } else {
        const paths = pagePathname.split('/').filter(Boolean);
        cleanedPaths = paths.map(path => {
            return startCase(path);
        }).join(': ');
    }


    const updatedPageName = (pagePrefix + cleanedPaths);

    // normalise : use so that there is always a space afer the colon
    // E.g. 'CBS:Super:My investment options' -> 'CBS: Super: My investment options'
    const normalisedNewPageName = updatedPageName.split(':').map(v => {
        return v.trim();
    })
        .join(': ');

    return normalisedNewPageName;
};


const adobeAnalytics = {
    pageLoad: () => {
        if (window) {
            const pageloadInit = async() => {
                const viewEnv = isMobileScreen() ? 'Mobile Page' : 'Desktop Page';

                const brand = getSiteBrand();

                // determine if user is in Cbus network from global site info. If not set assume client is NOT in cbus network false
                const isInCbusNetwork = window.__SITE_INFO__ ? !!(window.__SITE_INFO__.isInCbusNetwork) : false;

                let retryCount = 0;
                const maxRetries = 5;
                const retryDelay = 300;

                // Wait for the alloy function to be available, with a maximum number of retries to prevent infinite loop
                while (typeof window.alloy !== 'function' && retryCount < maxRetries) {
                    // eslint-disable-next-line no-await-in-loop
                    await sleep(retryDelay);
                    retryCount += 1;
                }

                const ecid = await GetECID();

                const currentDate = new Date();

                const normalisedPageName = retrievePageName(window.location.href);

                const pageInfo = {
                    ViewEnvironment: viewEnv,
                    brand,
                    domain: window.location.hostname,
                    generator: 'opt',
                    pageName: normalisedPageName,
                    pageUrl: window.location.href,
                    visitDay: getDayAsString(currentDate),
                    visitTime: getTimeAsString(currentDate),
                    isCbusNetwork: isInCbusNetwork,
                    ecid,
                };

                if (typeof window.s === 'object') {
                    window.s.pageName = normalisedPageName;
                }
                window.digitalData = { page: { pageInfo } };
            };

            pageloadInit();
        }
    },
};

document.addEventListener('DOMContentLoaded', () => {
    adobeAnalytics.pageLoad();
});

// to test if the custom even is fired and the digitalData is updated when search is submitted, this can be removed later
// window.addEventListener('analytics.search.submit', () => {
//     console.info('Search submit event triggered with digitalData:', window.digitalData);
// });
